import Chart from "react-apexcharts";
import React, { useState, useEffect } from "react";

const Graph = ({ data }) => {
  const [state, setState] = useState({
    options: {
      colors: ["#FFFFFF", "#856E4F"],
      stroke: { curve: "smooth", width: 3 },
      chart: { id: "" },
      xaxis: { categories: [], labels: { style: { colors: "#FFFFFF" } } },
      yaxis: { labels: { style: { colors: "#FFFFFF" } } },
      legend: { labels: { colors: "#FFFFFF" } },
      tooltip: { theme: "dark", style: { colors: "#000000" } },
    },
    series: [],
  });

  useEffect(() => {
    if (data && data.length > 0) {
      const sortedData = data?.reverse(); 

      const categories = sortedData.map((item) => item.month);
      const debitedData = sortedData.map((item) => parseFloat(item.total_debited));
      const creditedData = sortedData.map((item) => parseFloat(item.total_credited));
    
      setState({
        options: {
          ...state.options,
          xaxis: { ...state.options.xaxis, categories },
        },
        series: [
          { name: "Total Debited", data: debitedData },
          { name: "Total Credited", data: creditedData },
        ],
      });
    }
  }, [data]);

  return (
    <div className="w-[100%] mx-auto bg-[#1D1D1C] rounded-2xl p-5 mt-5">
      <div className="flex md:flex-row flex-col items-center divide-x divide-white/30 gap-10">
        <div className="flex text-sm gap-3">
          <p className="font-medium">Total Transactions</p>
          <p className="font-extralight">Total Debits</p>
          <p className="font-extralight">Total Credits</p>
        </div>
        <div>
          <ul className="list-disc list-inside pl-5 flex items-center gap-5 text-xs mt-0.5">
            <li>Current Month</li>
            <li>Previous Months</li>
          </ul>
        </div>
      </div>
      <div>
        <Chart options={state.options} series={state.series} type="line" width="100%" height="175%" />
      </div>
    </div>
  );  
};

export default Graph;
